module.exports = ["No reviews found for your search"]


//////////////////
// WEBPACK FOOTER
// ./config/exports/reviews/hotels/DUB.json
// module id = 160
// module chunks = 119